<template>
  <div class="EditTemperatureAutomationWidget lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="EditTemperatureAutomationWidget-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="EditTemperatureAutomationWidget-main lxn-pos-rel">
      <div class="EditTemperatureAutomationWidget-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddTemperatureAutomationWidget_title1}}
          </template>
          <template v-slot:body>
            <div class="EditTemperatureAutomationWidget-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="EditTemperatureAutomationWidget-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="EditTemperatureAutomationWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="EditTemperatureAutomationWidget-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="EditTemperatureAutomationWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="EditTemperatureAutomationWidget-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="EditTemperatureAutomationWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="EditTemperatureAutomationWidget-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="EditTemperatureAutomationWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="EditTemperatureAutomationWidget-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="EditTemperatureAutomationWidget-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="EditTemperatureAutomationWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddTemperatureAutomationWidget_text1}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="WidgetName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddTemperatureAutomationWidget_namePlaceHolder" inputType="text" />
            </div>
            <div class="AddSingleSwitchWidget-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.Folder_text}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetFolder" :dropDownContex="dropDownTargetFolder" />
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddTemperatureAutomationWidget_title2}}
          </template>
          <template v-slot:body>
            <div class="EditTemperatureAutomationWidget-wrapper-field-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddTemperatureAutomationWidget_text2}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="automationType" :dropDownContex="dropDownAutomationType" :disabled="true" />
            </div>
            <div v-if="automationType == 0" class="EditTemperatureAutomationWidget-wrapper-field-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddTemperatureAutomationWidget_text3}}
            </div>
            <div v-if="automationType == 0" class="lxn-w100">
              <DropDown v-model="targetSeason" :dropDownContex="dropDownTargetSeason" :disabled="true" />
            </div>
            <div class="EditTemperatureAutomationWidget-wrapper-field-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddTemperatureAutomationWidget_text5}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetHub" :dropDownContex="dropDownTargetHub" :disabled="true" />
            </div>
            <div class="EditTemperatureAutomationWidget-wrapper-field-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddTemperatureAutomationWidget_text4}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetSensor" :dropDownContex="dropDownTargetSensor" />
            </div>
          </template>
        </TitleBox>
        <TitleBox v-if="automationType == 0 || automationType == 1  || automationType == 3" titleBgColor="#00AEEF" bgColor="#afd6e5">
          <template v-if="automationType == 3" v-slot:title>
            {{$store.getters.language.texts.AddTemperatureAutomationWidget_humidity_text}}
          </template>
          <template v-else v-slot:title>
            {{$store.getters.language.texts.AddTemperatureAutomationWidget_cool_text}}
          </template>
          <template v-slot:body>
            <div class="EditTemperatureAutomationWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddTemperatureAutomationWidget_cool_on_description}}
            </div>
            <CommandCreator v-model="generatedCommand_cool_on" titleBgColor="#00AEEF" :multiHub="false" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :loadFrom="generatedCommand_cool_on_loaded" />
            <div class="EditTemperatureAutomationWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddTemperatureAutomationWidget_cool_off_description}}
            </div>
            <CommandCreator v-model="generatedCommand_cool_off" titleBgColor="#00AEEF" :multiHub="false" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :loadFrom="generatedCommand_cool_off_loaded" />
          </template>
        </TitleBox>
        <TitleBox v-if="automationType == 0 || automationType == 2" titleBgColor="#FF946B" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddTemperatureAutomationWidget_heat_text}}
          </template>
          <template v-slot:body>
            <div class="EditTemperatureAutomationWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddTemperatureAutomationWidget_heat_on_description}}
            </div>
            <CommandCreator v-model="generatedCommand_heat_on" titleBgColor="#FF946B" bgColor="#FFFFFF" :multiHub="false" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :loadFrom="generatedCommand_heat_on_loaded" />
            <div class="EditTemperatureAutomationWidget-description lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddTemperatureAutomationWidget_heat_off_description}}
            </div>
            <CommandCreator v-model="generatedCommand_heat_off" titleBgColor="#FF946B" bgColor="#FFFFFF" :multiHub="false" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :loadFrom="generatedCommand_heat_off_loaded" />
          </template>
        </TitleBox>
      </div>
      <div class="EditTemperatureAutomationWidget-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddTemperatureAutomationWidget_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CommandCreator from '@/components/CommandCreator.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import CustomInput from '@/components/CustomInput.vue'
import DropDown from '@/components/DropDown.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'

var messaging = new Messaging(new Logger(false));

export default {
  name: 'EditTemperatureAutomationWidget',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    CommandCreator,
    DropDown
  },
  data: function () {
    return {
      widget: this.$store.state.widgets[this.$route.params.widgetIndex],
      WidgetName: '',
      input1State: '',
      activeBoxIndex: 0,
      automationType: 0,
      targetSeason: 0,
      targetSensor: 0,
      targetHub: 0,
      sensorList: [],
      generatedCommand_cool_on: [],
      generatedCommand_cool_off: [],
      generatedCommand_heat_on: [],
      generatedCommand_heat_off: [],
      generatedCommand_cool_on_loaded: [],
      generatedCommand_cool_off_loaded: [],
      generatedCommand_heat_on_loaded: [],
      generatedCommand_heat_off_loaded: [],
      targetFolder: 0,
      folderList: [],
    }
  },
  mounted: function () {
    this.WidgetName = this.widget.name;
    this.activeBoxIndex = this.widget.color;
    this.targetHub = this.$store.getters.getHubByUUID(this.widget.hubUUID).index;

    var hub = this.$store.getters.getHubByUUID(this.widget.hubUUID);
    if(!hub.isOwner){
      alert(this.$store.getters.language.texts.EditTemperatureAutomationWidget_alertNotOwner);
      this.$router.push('/home/dashboard/')
    }

    var coolOnCommandExists = false;
    var coolOffCommandExists = false;
    var heatOnCommandExists = false;
    var heatOffCommandExists = false;

    if(this.widget.settings.coolOnCommand.length != 0 && this.widget.settings.coolOnGeneratedCommand.length != 0){
      coolOnCommandExists = true;
      this.generatedCommand_cool_on_loaded = this.generatedLoadableCommands(this.widget.settings.coolOnGeneratedCommand);
    }

    if(this.widget.settings.coolOffCommand.length != 0 && this.widget.settings.coolOffGeneratedCommand.length != 0){
      coolOffCommandExists = true;
      this.generatedCommand_cool_off_loaded = this.generatedLoadableCommands(this.widget.settings.coolOffGeneratedCommand);
    }

    if(this.widget.settings.heatOnCommand.length != 0 && this.widget.settings.heatOnGeneratedCommand.length != 0){
      heatOnCommandExists = true;
      this.generatedCommand_heat_on_loaded = this.generatedLoadableCommands(this.widget.settings.heatOnGeneratedCommand);
    }

    if(this.widget.settings.heatOffCommand.length != 0 && this.widget.settings.heatOffGeneratedCommand.length != 0){
      heatOffCommandExists = true;
      this.generatedCommand_heat_off_loaded = this.generatedLoadableCommands(this.widget.settings.heatOffGeneratedCommand);
    }
    if (this.widget.settings.automationType == 3){
      this.automationType = 3
    }
    else if(coolOnCommandExists && coolOffCommandExists && heatOnCommandExists && heatOffCommandExists){
      this.automationType = 0;
    }else if(heatOnCommandExists && heatOffCommandExists){
      this.automationType = 2;
    }else if(coolOnCommandExists && coolOffCommandExists){
      this.automationType = 1;
    }else{
      alert(this.$store.getters.language.texts.EditSingleSwitchWidget_alertNotSync);
    }

    if(this.widget.settings.season == 'summer'){
      this.targetSeason = 0;
    }else if(this.widget.settings.season == 'winter'){
      this.targetSeason = 1;
    }

    for(var i = 0; i < this.sensorList.length; i++){
      if(this.sensorList[i].node.uuid == this.widget.settings.sensorUUID && this.sensorList[i].input.parameterId == this.widget.settings.sensorParameterId){
        this.targetSensor = i;
        break;
      }
    }

    for(let i = 0; i < this.folderList.length; i++){
      if(this.folderList[i].path == this.widget.path){
        this.targetFolder = i;
      }
    }
  },
  watch: {
    targetHub: function (){
      this.targetSensor = 0;
      this.generatedCommand_cool_on = [];
      this.generatedCommand_cool_off = [];
      this.generatedCommand_heat_on = [];
      this.generatedCommand_heat_off = [];
    },
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    dropDownAutomationType: function () {
      return {
        name: "EditTemperatureAutomationWidget-automationType",
        title: this.$store.getters.language.texts.AddTemperatureAutomationWidget_text2,
        selectedIndex: this.automationType,
        data: [
          {
            name: this.$store.getters.language.texts.AddTemperatureAutomationWidget_automationType1,
            icon: 'coolHeatColored',
          },
          {
            name: this.$store.getters.language.texts.AddTemperatureAutomationWidget_automationType2,
            icon: 'coolColored',
          },
          {
            name: this.$store.getters.language.texts.AddTemperatureAutomationWidget_automationType3,
            icon: 'heatColored',
          },
          {
            name: this.$store.getters.language.texts.AddTemperatureAutomationWidget_automationType4,
            icon: 'humidity',
          },
        ]
      }
    },
    dropDownTargetSeason: function () {
      return {
        name: "EditTemperatureAutomationWidget-targetSeason",
        title: this.$store.getters.language.texts.AddTemperatureAutomationWidget_text3,
        selectedIndex: this.targetSeason,
        data: [
          {
            name: this.$store.getters.language.texts.AddTemperatureAutomationWidget_targetSeason1,
            icon: 'heatColored',
          },
          {
            name: this.$store.getters.language.texts.AddTemperatureAutomationWidget_targetSeason2,
            icon: 'coolColored',
          },
        ]
      }
    },
    dropDownTargetHub: function () {
      var dropDownTargetHub = {
        name: "EditTemperatureAutomationWidget-TargetHubs",
        title: this.$store.getters.language.texts.AddTemperatureAutomationWidget_text5,
        selectedIndex: this.targetHub,
        data: []
      };
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        dropDownTargetHub.data.push({
          name: this.$store.state.hubs[i].name,
          icon: "hub",
        })
      }
      return dropDownTargetHub;
    },
    dropDownTargetSensor: function () {
      this.sensorListCleaner();
      var dropDownTargetSensor = {
        name: "EditTemperatureAutomationWidget-TargetSensor",
        title: this.$store.getters.language.texts.AddTemperatureAutomationWidget_text4,
        selectedIndex: this.targetSensor,
        data: []
      };
      for(var i = 0; i < this.$store.state.nodes.length; i++){
        if(this.$store.state.nodes[i].hubUUID == this.$store.state.hubs[this.targetHub].uuid){
          for(var j = 0; j < this.$store.state.nodes[i].inputs.length; j++){
            if(this.$store.state.nodes[i].inputs[j].type == 'temperatureSensor'){
              this.sensorListSetter(
                {
                  node: this.$store.state.nodes[i],
                  input: this.$store.state.nodes[i].inputs[j],
                  outputIndex: j,
                }
              );
              dropDownTargetSensor.data.push({
                name: this.$store.state.nodes[i].name + ' > ' + this.$store.state.nodes[i].inputs[j].name,
                icon: this.$store.state.nodes[i].inputs[j].icon,
              })
            }
          }
        }
      }
      return dropDownTargetSensor;
    },
    dropDownTargetFolder: function () {
      this.folderListCleaner();
      var dropDownTargetFolder = {
        name: "AddSingleSwitchWidget-TargetOutputNoNc",
        title: this.$store.getters.language.texts.ChooseOutput_text,
        selectedIndex: this.targetFolder,
        data: [
          {
            name: this.$store.getters.language.texts.Root_text,
            icon: 'folder',
          },
        ]
      };
      this.folderListSetter(
        {
          widgetIndex: -1,
        }
      );
      for(var i = 0; i < this.$store.state.widgets.length; i++){
        if(this.$store.state.widgets[i].type == "folderWidget"){
          var folderWidget = this.$store.state.widgets[i];
          var parentPath = folderWidget.settings.parent;
          var parentFolder = this.$store.state.widgets.filter(widget => widget.settings.path == parentPath);
          var folderName = folderWidget.name;
          while(parentFolder.length){
            folderName = parentFolder[0].name + " > " + folderName;
            parentPath = parentFolder[0].settings.parent;
            parentFolder = this.$store.state.widgets.filter(widget => widget.settings.path == parentPath);
          }
          this.folderListSetter(
            {
              path: folderWidget.settings.path,
            }
          );
          dropDownTargetFolder.data.push({
            name: folderName,
            icon: "folder",
          })
        }
      }
      return dropDownTargetFolder;
    },
  },
  methods: {
    folderListSetter: function (obj) {
      this.folderList.push(obj);
    },
    folderListCleaner: function () {
      this.folderList = [];
    },
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    sensorListSetter: function (obj) {
      this.sensorList.push(obj);
    },
    sensorListCleaner: function () {
      this.sensorList = [];
    },
    generatedLoadableCommands: function (commandContex) {
      var loadedCommand = [];
      for(var i = 0; i < commandContex.length; i++){
        for(var j = 0; j < commandContex[i].actions.length; j++){
          var hub = this.$store.getters.getHubByUUID(commandContex[i].hubUUID);
          var node = this.$store.getters.getNodeByUUID(commandContex[i].actions[j].nodeUUID);
          var state = commandContex[i].actions[j].state;
          var delay = commandContex[i].actions[j].timeDelay;
          var output = null;
          var outputFound = false;
          if(commandContex[i].actions[j].outputType == "IrDevice"){
            for(var k = 0; k < node.outputs.length; k++){
              if(node.outputs[k].settings.brand == commandContex[i].actions[j].outputSettings.brand && node.outputs[k].settings.deviceType == commandContex[i].actions[j].outputSettings.deviceType && node.outputs[k].settings.model == commandContex[i].actions[j].outputSettings.model){
                output = node.outputs[k];
                outputFound = true;
                break;
              }
            }
          }else{
            for(k = 0; k < node.outputs.length; k++){
              if(node.outputs[k].parameterId == commandContex[i].actions[j].parameterId){
                output = node.outputs[k];
                outputFound = true;
                break;
              }
            }
          }
          if(outputFound){
            loadedCommand.push({
              hub: hub,
              node: node,
              output: output,
              state: state,
              delay: delay
            });
          }
        }
      }
      return loadedCommand;
    },
    generateNodeActions: function (nodeActions) {
      var generatedNodeActions = [];
      var typeOfAction = 0;
      var valueOfChange = 0;

      for(var i = 0; i < nodeActions.length; i++){
        var isNodeNew = true;
        if(nodeActions[i].outputType != "IrDevice"){
          if(nodeActions[i].state == 'on'){
            typeOfAction = CONFIGS.ACTION_TYPE_SET;
            valueOfChange = 1;
          }else if(nodeActions[i].state == 'off'){
            typeOfAction = CONFIGS.ACTION_TYPE_SET;
            valueOfChange = 0;
          }
        }else{
          var deviceType = nodeActions[i].outputSettings.deviceType;
          var brand = nodeActions[i].outputSettings.brand;
          var model = nodeActions[i].outputSettings.model;
          var irDevice = NODE7.devices[deviceType].brands[brand].devices[model];

          valueOfChange = messaging.utility.arrayTo128(irDevice.commands[nodeActions[i].state.targetCommandIndex].command);
          typeOfAction = CONFIGS.ACTION_TYPE_SET;
        }
        var action = {
          parameterId: nodeActions[i].parameterId,
          valueOfChange: valueOfChange,
          typeOfAction: typeOfAction,
          timeDelay: nodeActions[i].timeDelay,
        }

        for(var j = 0; j < generatedNodeActions.length; j++){
          if(generatedNodeActions[j].nodeUUID == nodeActions[i].nodeUUID){
            generatedNodeActions[j].actions.push(action);
            isNodeNew = false;
            break;
          }
        }
        if(isNodeNew){
          generatedNodeActions.push(
            {
              nodeUUID: nodeActions[i].nodeUUID,
              actions: [action]
            }
          );
        }
      }
      return generatedNodeActions;
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.WidgetName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddSingleSwitchWidget_alert1);
      }else if(this.sensorList.length == 0){
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertNoSensor);
      }else if(this.automationType == 0 && this.generatedCommand_cool_on.length == 0){
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertCoolOnNoCommand);
      }else if(this.automationType == 0 && this.generatedCommand_cool_off.length == 0){
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertCoolOffNoCommand);
      }else if(this.automationType == 0 && this.generatedCommand_heat_on.length == 0){
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertHeatOnNoCommand);
      }else if(this.automationType == 0 && this.generatedCommand_heat_off.length == 0){
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertHeatOffNoCommand);
      }else if(this.automationType == 1 && this.generatedCommand_cool_on.length == 0){
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertCoolOnNoCommand);
      }else if(this.automationType == 1 && this.generatedCommand_cool_off.length == 0){
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertCoolOffNoCommand);
      }else if(this.automationType == 2 && this.generatedCommand_heat_on.length == 0){
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertHeatOnNoCommand);
      }else if(this.automationType == 2 && this.generatedCommand_heat_off.length == 0){
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertHeatOffNoCommand);
      }else if(this.automationType == 3 && this.generatedCommand_cool_on.length == 0){
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertNoOnCommand);
      }else if(this.automationType == 3 && this.generatedCommand_cool_off.length == 0){
        alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertNoOffCommand);
      }else{
        this.$store.commit('setAppBusy', true);

        if(this.automationType == 0){
          var season = this.targetSeason == 0 ? 'summer' : 'winter';
        }else if(this.automationType == 1){
          season = 'summer';
        }else{
          season = 'winter';
        }

        var hub = this.$store.state.hubs[this.targetHub];
        var sensorUUID = this.sensorList[this.targetSensor].node.uuid;
        var sensorParameterId = this.sensorList[this.targetSensor].input.parameterId;

        var instructionList = [];
        var watchList = [];
        var newGroupId = this.widget.settings.groupId;

        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: hub.psk,
          destinationUUID: hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });

        //eventId for cool on
        var coolOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (newGroupId & 0xFF) << 3);
        //dummy eventId for cool on
        var coolOnDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (newGroupId & 0xFF) << 3) + 4;

        //eventId for cool off
        var coolOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (newGroupId & 0xFF) << 3) + 1;
        //dummy eventId for cool off
        var coolOffDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (newGroupId & 0xFF) << 3) + 5;

        //eventId for heat on
        var heatOnActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (newGroupId & 0xFF) << 3) + 2;
        //dummy eventId for heat on
        var heatOnDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (newGroupId & 0xFF) << 3) + 6;

        //eventId for heat off
        var heatOffActualEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (newGroupId & 0xFF) << 3) + 3;
        //dummy eventId for heat off
        var heatOffDummyEventId = (CONFIGS.TEMPERATURE_AUTOMATION_EVENT_ID_PREFIX << 8) + ( (newGroupId & 0xFF) << 3) + 7;

        var coolOnCommand = [];
        var coolOffCommand = [];
        var heatOnCommand = [];
        var heatOffCommand = [];
        if(this.automationType == 0 || this.automationType == 1 || this.automationType == 3){
          var nodeActions_cool_on = this.generateNodeActions(this.generatedCommand_cool_on[0].actions);
          var nodeActions_cool_off = this.generateNodeActions(this.generatedCommand_cool_off[0].actions);
          messagingHook.setParametersOfNodesSerializer(coolOnCommand, {nodeActions: nodeActions_cool_on});
          messagingHook.setParametersOfNodesSerializer(coolOffCommand, {nodeActions: nodeActions_cool_off});

          instructionList.push({
            eventIdToWatch: coolOnActualEventId,
            commandLength: coolOnCommand.length,
            commandToSend: coolOnCommand,
          });
          instructionList.push({
            eventIdToWatch: coolOffActualEventId,
            commandLength: coolOffCommand.length,
            commandToSend: coolOffCommand,
          });
        }
        if(this.automationType == 0 || this.automationType == 2){
          var nodeActions_heat_on = this.generateNodeActions(this.generatedCommand_heat_on[0].actions);
          var nodeActions_heat_off = this.generateNodeActions(this.generatedCommand_heat_off[0].actions);
          messagingHook.setParametersOfNodesSerializer(heatOnCommand, {nodeActions: nodeActions_heat_on});
          messagingHook.setParametersOfNodesSerializer(heatOffCommand, {nodeActions: nodeActions_heat_off});

          instructionList.push({
            eventIdToWatch: heatOnActualEventId,
            commandLength: heatOnCommand.length,
            commandToSend: heatOnCommand,
          });
          instructionList.push({
            eventIdToWatch: heatOffActualEventId,
            commandLength: heatOffCommand.length,
            commandToSend: heatOffCommand,
          });
        }
        if(season == 'summer'){
          watchList.push({
            deviceUUID: sensorUUID,
            parameterId: sensorParameterId,
            valueOfChange: this.widget.settings.setPoint + CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
            relation: CONFIGS.RELATION_GREATER_THAN_EQUAL,
            eventId: coolOnActualEventId,
          });
          watchList.push({
            deviceUUID: sensorUUID,
            parameterId: sensorParameterId,
            valueOfChange: this.widget.settings.setPoint - CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
            relation: CONFIGS.RELATION_LESS_THAN_EQUAL,
            eventId: coolOffActualEventId,
          });
        }else if(season == 'winter'){
          watchList.push({
            deviceUUID: sensorUUID,
            parameterId: sensorParameterId,
            valueOfChange: this.widget.settings.setPoint - CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
            relation: CONFIGS.RELATION_LESS_THAN_EQUAL,
            eventId: heatOnActualEventId,
          });
          watchList.push({
            deviceUUID: sensorUUID,
            parameterId: sensorParameterId,
            valueOfChange: this.widget.settings.setPoint + CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
            relation: CONFIGS.RELATION_GREATER_THAN_EQUAL,
            eventId: heatOffActualEventId,
          });
        }
        this.$store.dispatch('modifyHubInstructions', {
          messagingHook: messagingHook,
          hubUUID: hub.uuid,
          instructions: instructionList,
        })
        .then( () => {
          this.$store.dispatch('modifyParameterWatches', {
            messagingHook: messagingHook,
            hubUUID: hub.uuid,
            bodyContent: {
              watchList: watchList,
            }
          })
          .then( () => {
            this.$store.dispatch('readNodeInstructions', {
              messagingHook: messagingHook,
              hubUUID: hub.uuid,
              nodeUUID: sensorUUID
            })
            .then( response => {
              var sensorInstructionList = response.body.bodyContent.instructionList;
              var newSensorInstructionList = [];
              for(var i = 0; i < sensorInstructionList.length; i++){
                if(season == 'summer'){
                  if(sensorInstructionList[i].internalAction.valueOfChange != coolOnDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != coolOffDummyEventId){
                    newSensorInstructionList.push(sensorInstructionList[i]);
                  }
                }else if(season == 'winter'){
                  if(sensorInstructionList[i].internalAction.valueOfChange != heatOnDummyEventId && sensorInstructionList[i].internalAction.valueOfChange != heatOffDummyEventId){
                    newSensorInstructionList.push(sensorInstructionList[i]);
                  }
                }
              }
              if (this.automationType == 3){
                newSensorInstructionList.push({
                  eventToWatch: {
                    parameterId: sensorParameterId,
                    valueToReach: CONFIGS.HUMIDITY_AUTOMATION_SETPOINT + CONFIGS.HUMIDITY_AUTOMATION_OFFSET,
                    direction: CONFIGS.EVENT_DIRECTION_RISING,
                  },
                  internalAction: {
                    parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                    valueOfChange: coolOnDummyEventId,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  },
                  timeDelay: 0,
                })
                newSensorInstructionList.push({
                  eventToWatch: {
                    parameterId: sensorParameterId,
                    valueToReach: CONFIGS.HUMIDITY_AUTOMATION_SETPOINT - CONFIGS.HUMIDITY_AUTOMATION_OFFSET,
                    direction: CONFIGS.EVENT_DIRECTION_FALLING,
                  },
                  internalAction: {
                    parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                    valueOfChange: coolOffDummyEventId,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  },
                  timeDelay: 0,
                })              
              }
              if(season == 'summer'){
                newSensorInstructionList.push({
                  eventToWatch: {
                    parameterId: sensorParameterId,
                    valueToReach: CONFIGS.TEMPERATURE_AUTOMATION_COOL_SETPOINT + CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                    direction: CONFIGS.EVENT_DIRECTION_RISING,
                  },
                  internalAction: {
                    parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                    valueOfChange: coolOnDummyEventId,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  },
                  timeDelay: 0,
                })
                newSensorInstructionList.push({
                  eventToWatch: {
                    parameterId: sensorParameterId,
                    valueToReach: CONFIGS.TEMPERATURE_AUTOMATION_COOL_SETPOINT - CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                    direction: CONFIGS.EVENT_DIRECTION_FALLING,
                  },
                  internalAction: {
                    parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                    valueOfChange: coolOffDummyEventId,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  },
                  timeDelay: 0,
                })
              }else if(season == 'winter'){
                newSensorInstructionList.push({
                  eventToWatch: {
                    parameterId: sensorParameterId,
                    valueToReach: CONFIGS.TEMPERATURE_AUTOMATION_HEAT_SETPOINT - CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                    direction: CONFIGS.EVENT_DIRECTION_FALLING,
                  },
                  internalAction: {
                    parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                    valueOfChange: heatOnDummyEventId,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  },
                  timeDelay: 0,
                })
                newSensorInstructionList.push({
                  eventToWatch: {
                    parameterId: sensorParameterId,
                    valueToReach: CONFIGS.TEMPERATURE_AUTOMATION_HEAT_SETPOINT + CONFIGS.TEMPERATURE_AUTOMATION_OFFSET,
                    direction: CONFIGS.EVENT_DIRECTION_RISING,
                  },
                  internalAction: {
                    parameterId: NODE7.NOTIFY_HUB.PARAMETER_ID,
                    valueOfChange: heatOffDummyEventId,
                    typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  },
                  timeDelay: 0,
                })
              }
              this.$store.dispatch('setInstructionsOnDevice', {
                messagingHook: messagingHook,
                hubUUID: hub.uuid,
                nodeUUID: sensorUUID,
                instructions: newSensorInstructionList,
              })
              .then( () => {
                //It was successfull!!! Do nothing.
              })
              .catch( () => {
                alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertSensorFailed);
              })
              .finally( () => {
                // this.$router.push('/home/dashboard/');
                // this.$store.commit('setAppBusy', false);
              })
            })
            .catch( () => {
              alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertSensorFailed);
            })
            .finally( () => {
              var path = this.folderList[this.targetFolder].path;
              this.$store.commit('editWidget', {
                widgetIndex: this.$route.params.widgetIndex,
                widget: {
                  name: this.WidgetName,
                  color: this.activeBoxIndex,
                  type: "temperatureAutomationWidget",
                  hubUUID: this.$store.state.hubs[this.targetHub].uuid,
                  visible: true,
                  path: path,
                  settings: {
                    sensorUUID: this.sensorList[this.targetSensor].node.uuid,
                    sensorParameterId: sensorParameterId,
                    season: season,
                    setPoint: this.widget.settings.setPoint,
                    coolOnCommand: coolOnCommand,
                    coolOffCommand: coolOffCommand,
                    heatOnCommand: heatOnCommand,
                    heatOffCommand: heatOffCommand,
                    coolOnGeneratedCommand: this.generatedCommand_cool_on,
                    coolOffGeneratedCommand: this.generatedCommand_cool_off,
                    heatOnGeneratedCommand: this.generatedCommand_heat_on,
                    heatOffGeneratedCommand: this.generatedCommand_heat_off,
                    groupId: newGroupId,
                    automationType:this.automationType,
                    isActive: this.widget.settings.isActive,
                  }
                },
              });
              this.$store.commit('saveState');
              this.$router.push('/home/dashboard/');
              this.$store.commit('setAppBusy', false);
            });
          })
          .catch( response => {
            if(response.rejectCode == 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
            alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertHubFailed);
            this.$store.commit('setAppBusy', false);
          })
        })
        .catch( response => {
          if(response.rejectCode == 2){
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }
          alert(this.$store.getters.language.texts.AddTemperatureAutomationWidget_alertHubFailed);
          this.$store.commit('setAppBusy', false);
        })          
      }
    },
  }
}
</script>

<style>
  .EditTemperatureAutomationWidget-topCurve-wrapper {
    height: 200px;
  }
  .EditTemperatureAutomationWidget-main {
    z-index: 2;
  }
  .EditTemperatureAutomationWidget-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .EditTemperatureAutomationWidget-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .EditTemperatureAutomationWidget-wrapper-colors {
    height: 50px;
  }
  .EditTemperatureAutomationWidget-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .EditTemperatureAutomationWidget-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .EditTemperatureAutomationWidget-color.active .EditTemperatureAutomationWidget-selectedColor {
    opacity: 1;
  }
  .EditTemperatureAutomationWidget-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .EditTemperatureAutomationWidget-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .EditTemperatureAutomationWidget-wrapper-name-text:first-child {
    height: 30px;
    padding-top: 0;
  }
  .EditTemperatureAutomationWidget-wrapper-field-text {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .EditTemperatureAutomationWidget-description {
    margin-top: 14px;
    margin-bottom: 14px;
  }
 .EditTemperatureAutomationWidget-description:first-child {
    margin-top: 0;
  }
</style>
